import React, { useContext } from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { Price, Typography } from 'fronton-react';
import { DataContext } from 'entries/common/widgets/context';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { useCalculationState } from 'pages/calculation/store/calculation';
import { Cart } from './Cart';

export const CalculationFooterComponent = () => {
  const { mobile } = useBreakpoints() ?? {};
  const remoteData = useContext(DataContext);

  const { calculationFormState, totalAmount } = useCalculationState();

  if (remoteData) {
    const { productId } = remoteData;
    const count = Number(calculationFormState.count);
    const { addToCartIsSuccessful } = calculationFormState;
    const sumLabelProps = mobile
      ? {
          variant: 'caption',
        }
      : {
          variant: 'm',
          color: 'text-primary',
          size: 'body_short',
        };
    const priceSize = mobile ? 'l' : 'xl';

    return (
      <>
        <Cart count={count} productId={productId} />
        {mobile && addToCartIsSuccessful ? null : (
          <ContainerPrice>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            <Typography {...sumLabelProps} className={sumLabel}>
              Сумма:
            </Typography>
            <Price fraction size={priceSize} value={totalAmount} variant="medium" />
          </ContainerPrice>
        )}
      </>
    );
  }

  return null;
};

const ContainerPrice = styled.div`
  display: flex;
  align-items: baseline;
  gap: var(--space-100);
  margin-left: auto;
  white-space: nowrap;
`;

const sumLabel = css`
  white-space: nowrap;
`;
